import React, { useEffect, useRef } from "react";

const ScrollingText = () => {
  const scrollRef = useRef(null);

  useEffect(() => {
    const el = scrollRef.current;
    let animationFrame;
    let position = 0;

    const scroll = () => {
      if (!el) return;
      position -= 1;
      if (Math.abs(position) >= el.scrollWidth / 2) {
        position = 0;
      }
      el.style.transform = `translateX(${position}px)`;
      animationFrame = requestAnimationFrame(scroll);
    };

    animationFrame = requestAnimationFrame(scroll);

    return () => cancelAnimationFrame(animationFrame);
  }, []);

  return (
    <div style={{ overflow: "hidden", whiteSpace: "nowrap", background: "#532200", color: "#fff", padding: "20px" }}>
      <div
        ref={scrollRef}
        style={{
          display: "inline-block",
          willChange: "transform",
          whiteSpace: "nowrap",
        }}
      >

        <div className="add-list">
          <span>We provide</span>
          <span>Business Loans</span>
          <span>Home Loans</span>
          <span>Credit Cards</span>
          <span>Personal Loans</span>
          <span>Mortgage Loans</span>
          <span>Gold Loans</span>
          <span>Education Loans</span>
          <span>Car Loans</span>
        </div>

        <div className="add-list">
          <span>We provide</span>
          <span>Business Loans</span>
          <span>Home Loans</span>
          <span>Credit Cards</span>
          <span>Personal Loans</span>
          <span>Mortgage Loans</span>
          <span>Gold Loans</span>
          <span>Education Loans</span>
          <span>Car Loans</span>
        </div>

        
      </div>
    </div>
  );
};

export default ScrollingText;
